export default "__VITE_ASSET__beb6dfd7__"